import Vue from 'vue'
import axios from 'axios'
import Vuex from 'vuex'
import store from '@/store'
import global_ from './config'//引用模块进来
import qs from 'qs'


export default {
    //关闭model
    hideModel(name) {
       setTimeout(() => {
	      UIkit.modal("."+name).hide();                      
	    },500) 
    },
    //打开model
    showModel(name) {
       setTimeout(() => {
        UIkit.modal("."+name).show();                      
      },500) 
    },
    //千分位数字
    NumFormat(a) {
        // console.log(value);
          if (!a){
           return ' '
            } 
          var intPartFormat = (Math.round(a * 100) / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {return $1 + ",";});
          return intPartFormat
    },
    FormateText(v){
      if(!v){
        return
      }
        let val = v.replace(/[\'\"\\\/\b\f\n\r\t]/g, ''); 
        return val
    },
    FormateNum(v){
      if(!v){
        return
      }
      let val = v.replace(/\s*/g,"");
      return val
    },


    subStrDate(v,n){      
      if(!v){
        return
      }                
      let val = v.substr(0,n)      
      return val
    },

    subStrText(v){      
      if(!v){
        return
      }      
      let val = ''
      if(v.length > 15){
         val = v.substr(0,15) + '...'
      }else{
         val = v
      }
      return val
    },
    subStrLangText(v,num){  
      if(!v){
        return
      }          
      let val = ''
      if(v.length > num){
         val = v.substr(0,num) + '...'
      }else{
         val = v
      }
      return val
    },
    //升级版，可指定填充字符
    strProcessing(v,start = 0,end = 0, fill = '*', fill_num = 6){
      let val = ''
      if(start < 0 || end < 0){
        return '-'
      }
      let min_len = start > end ? start:end
      if(v.length < min_len){
        return v
      }
      if(fill == ''){
        return v
      }
      if(parseInt(fill_num) < 1){
        return v
      }
      val = v.substr(0,start) + fill.repeat(parseInt(fill_num)) + v.substr(-1*end);
      return val
    },

    subStrFront(v,start = 0,end = 0){
      let val = ''
      if(start < 0 || end < 0){
        return '-'
      }
      let min_len = start > end ? start:end
      if(v.length < min_len){
        return v
      }
      val =  v.substr(end);
      
      return val
    },
    
    
    checkUrl(url){
      var reg=/^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;      
      return reg.test(url)      
    },

    checkUrl2(url){
      var reg=/^(https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;      
      return reg.test(url)      
    },



    checkPwd(v){
      var pwpattent = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*?[#?!@$%^&*-]).{8,20}/;
        return pwpattent.test(v)                  
    },
    checkEmail(v){
      var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
      return reg.test(v)                  
    },
    checkIPV4(v){
      // var reg = new RegExp("/^0*([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])\.0*([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])\.0*([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])\.0*([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])$/");
      // var reg = new RegExp("/^(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}$/");

      var reg = /^((2[0-4][0-9])|(25[0-5])|(1[0-9]{0,2})|([1-9][0-9])|([1-9]))\.(((2[0-4][0-9])|(25[0-5])|(1[0-9]{0,2})|([1-9][0-9])|([0-9]))\.){2}((2[0-4][0-9])|(25[0-5])|(1[0-9]{0,2})|([1-9][0-9])|([1-9]))$/

      console.log(reg.test(v))      
      return reg.test(v)
    },
    checkIPV6(v){
      var reg = new RegExp("^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$");
      return reg.test(v)
    },
    checkPhone(v){
      var reg = new RegExp("/^[0-9-+ _]{0,40}$/");
      return reg.test(v)
    },
    today(){
      return parseInt(new Date().getTime()/1000);
    },
    newdate(v){
     return parseInt(new Date(v).getTime()/1000);
    },
    // 获取数组或者健值对的数量
    get_json_count(list){
      if(!list){
        return 0
      }else{      
        var arr = []
        for(let k in list){
          arr.push(list[k])
        }
        return arr.length
      }
    } 
}

// 获取时间方法
class DateTime {
  // 构造方法
  constructor() {
    // 列举Week
    this.weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    // 获取当前时间
    this.Date = new Date();
    // 获取当前年
    this.year = this.Date.getFullYear();
    // 获取当前月
    this.month = this.Date.getMonth() + 1;
    // 获取当前日
    this.date = this.Date.getDate();
    // 获取当前星期几
    this.day = this.Date.getDay();
    // 获取小时
    this.hour = this.Date.getHours();
    // 获取分钟
    this.minute = this.Date.getMinutes();
    // 获取秒
    this.second = this.Date.getSeconds();
    // 自动补零
    this.month = (this.month < 10) ? '0' + this.month : this.month = this.month;
    this.date =  (this.date < 10) ? '0' + this.date : this.date = this.date;
    this.minute = (this.minute < 10) ? '0' + this.minute : this.minute = this.minute;
    this.second = (this.second < 10) ? '0' + this.second : this.second = this.second;
  };
  /**
  * 取当前日期
  * @returns {string}
  */
  getDate() {
    return this.year + '-' + this.month + '-' + this.date + ' ' + ' ';
  };
  /**
  * 获取当前时间
  * @returns {string}
  */
  getTime() {
    return this.hour + ':' + this.minute + ':' + this.second;
  };
  /**
  * 获取当前星期几
  *@returns {string}
  */
  getWeek() {
    return this.weekday[this.day]
  };
}
export { DateTime }










// WEBPACK FOOTER //
// ./src/components/common/resouces/common.js